<template>
    <div name="hospital" class="wrapper">
        <div class="page" v-if="isView">
            <banner 
                v-if="hospital"
                :images="hospital.promotion_data.profile.images"
            />
            <info 
                v-if="hospital"
                :promotion_data="hospital.promotion_data"
                @call="tel(hospital.promotion_data.profile.representative_number)"
            />
            <medicals 
                v-if="hospital"
                :departments="hospital.promotion_data.departments"
            />
            <doctors 
                v-if="hospital"
                :doctor_list="hospital.doctor_list"
            />
            <div class="bottom-button">
                <div class="call-button" @click="hospital.additional_link === null ? tel(hospital.promotion_data.profile.representative_number) : openUlr(hospital.additional_link)">
                    <img style="width: 24px;" src="../../assets/call_icn.png" />
                    <span style="margin-left: 10px;">{{hospital.additional_link === null ? '대면진료 문의하기' : '대면진료 예약하기'}}</span></div>
                <div class="kakao-button" @click="login">
                    <img style="width: 24px;" src="../../assets/kakao.png" />
                    <span style="margin-left: 10px;">비대면진료 예약하기</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';
import axios from 'axios';
import Banner from '@/components/hospital/Banner';
import Info from '@/components/hospital/Info';
import Medicals from '@/components/hospital/Medicals';
import Doctors from '@/components/hospital/Doctors';

export default {
    components: { 
        Banner,
        Info,
        Medicals,
        Doctors
    },
    name: 'hospital',
    data: function()
    {
        return {
            uuid: null,
            isView: false,
            data: [
                {uuid: "1607405803", name: '도브의원', banner: 'https://d1xox7kqzxfqzz.cloudfront.net/admin/promotion/1607405803/기광고확정안.jpg'},
                {uuid: "2439198062", name: '고양신세계안과의원', banner: 'https://d1xox7kqzxfqzz.cloudfront.net/admin/promotion/16825588576/고양신세계안과의원_1.png'},
                {uuid: "1678194785", name: '신세계 이비인후과', banner: 'https://d1xox7kqzxfqzz.cloudfront.net/admin/promotion/16825588576/신세계이비인후과_1.jpg'},
            ],
            selected: null,
            hospital: null
        }
    },
    mounted: async function()
    {
        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        this.uuid = this.$route.params.uuid;

        if(this.uuid === null || this.uuid === undefined || this.uuid === '' || this.uuid === '0')
        {
            
        }
        if(this.$route.query.kakao)
        { 
            this.isView = false;
            this.afterLogin(this.$route.query.kakao);
        }
        else
        {
            // this.selected = this.data.find(item => item.uuid === this.uuid)
            this.isView = true;

            // fetch data 
            const url = `${process.env.ADMIN_API_ROOT}/v1/hospital/${this.uuid}/promotion`;                
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `${process.env.ADMIN_API_KEY}` //GihCEC8mQTUaT_8vbNc3-kEkQCEskV .KK9vp3Kaa7pHU8Vvjx7BQg3xsVcU_
                }
            });
            this.hospital = response.data.data;
            
        }
    },
    methods: {
        login: function()
        {
            const REST_API_KEY = process.env.KAKAO_REST_API_KEY;
            const REDIRECT_URI = process.env.KAKAO_REDIRECT_URI;
            let STATE = `${process.env.LOGIN_URI}/hospital/${this.uuid}`;
            window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&response_type=code&prompt=login&state=${STATE}`;
        },
        afterLogin: function(kakaoId)
        {
            // alert(kakaoId)
            this.$store.dispatch(Constant.AUTH_INAPP, {type: this.uuid, id: kakaoId, ref: null})
                .then((response) => {
                    window.location.href = response; 
                })
                .catch((err) => {

                })
        }, 
        openUlr: function(url)
        {
             window.location.href = url;
        },
        tel: function(phone)
        {
            window.location.href = `tel:${phone}`;
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        height: 100dvh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .page {
        width: 100%;
        height: 100dvh;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding: 0 16px 200px 16px;
        overflow-y: auto;
    
    }
    .row {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        box-sizing: border-box;
    }

    .title {
        color: #1A1B1E;
        font-family: Pretendard;
        font-size: 5vh;
        font-style: normal;
        font-weight: 700;
    }
    .kakao-button {
        width: 100%;
        display: flex;
        height: 55px;
        border-radius: 6px;
        background: #FFE601;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        position: relative;
        cursor: pointer;
    }
    .kakao-button-icon {
        margin-right: 8px;
        width: 24px;
    }
   
    .line {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .description {
            color: #6E717D;
            font-family: Pretendard;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            margin-top: 16px;
            line-height: 23px;
            text-align: center;
    }
    .small {
        color: #6E717D;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        margin-top: 20px;
        opacity: 0.8;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
            height: 100dvh;
        }
    }
    @media (min-height: 580px) {
       .title {
            color: #1A1B1E;
            font-family: Pretendard;
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
        }

    }
    .responsive-img {
        width: 100%;
    }
    .bottom-button {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        max-width: 600px;
        width: 100%;
        position: fixed;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: 0;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        padding: 16px;
        box-sizing: border-box;
        /* background: linear-gradient(0deg, #F3F5F8 0%, rgba(255, 255, 255, 0.00) 255.33%); */
        background: #F3F5F8;
    }
    .kakao-button {
        display: flex;
        width: 100%;
        height: 54px;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        background: #FBE44D;
        color: rgba(0, 0, 0, 0.85);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }
    .call-button {
        display: flex;
        width: 100%;
        height: 54px;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        color: rgba(0, 0, 0, 0.85);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }
</style>


// WEBPACK FOOTER //
// src/page/hospital/index.vue